import Image, { StaticImageData } from 'next/image'
import React from 'react'
import { authCircleSvg } from '../constants/image'


type AuthBgWrapperProps = {

    /**
     * The children of the component, eg: form elements
     */
    children: React.ReactNode,

    /**
     * The background image of the auth screen
     */
    image: StaticImageData,
 
}

/**
 * This components used for wrapping all auth screen with given bg 
 */
function AuthBgWrapper({ children, image }: AuthBgWrapperProps) {
    return (
        <div className="min-h-screen relative grid">
            <div className="absolute w-full h-full z-10 bg-[#00376433] pointer-events-none">
            </div>
            <Image
                src={authCircleSvg}
                alt="Background circle"
                className="absolute bottom-0 left-0 z-10 pointer-events-none"
                priority
            />
            <Image
                src={image}
                alt="Background image"
                className="w-full h-full position absolute inset-0 object-cover"
                priority
                placeholder="blur"
            />
            <div className="container flex flex-col items-end justify-center w-full h-full relative z-20 px-4 py-2 md:py-4">
                {children}
            </div>
        </div>
    )
}

export default AuthBgWrapper